import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import PageShell from '@/components/site/PageShell';
import PageHero from '@/components/site/PageHero';
import AfterSubmitSteps from '@/components/site/AfterSubmitSteps';
import ContactForm from '@/components/site/ContactForm';

const COPY = {
  it: {
    eyebrow: 'Contatti',
    title_a: 'Parliamo del tuo studio.',
    title_b: 'Concretamente.',
    subtitle:
      'Niente moduli infiniti, niente call obbligatorie. Lasciaci i dati essenziali, ti rispondiamo entro 24h con una proposta concreta — oppure scrivici direttamente su WhatsApp.',
  },
  en: {
    eyebrow: 'Contact',
    title_a: 'Let\'s talk about your practice.',
    title_b: 'Concretely.',
    subtitle:
      'No endless forms, no mandatory calls. Leave us the essentials, we reply within 24h with a concrete proposal — or message us directly on WhatsApp.',
  },
};

export const ContactPage = () => {
  const { locale } = useLanguage();
  const c = COPY[locale] || COPY.it;

  return (
    <PageShell title={c.eyebrow} testId="pv-contact-page">
      <PageHero
        eyebrow={c.eyebrow}
        title_a={c.title_a}
        title_b={c.title_b}
        subtitle={c.subtitle}
        ctas={['whatsapp', 'brochure']}
        source="contact-hero"
        testId="pv-contact-page-hero"
      />
      <AfterSubmitSteps variant="form" testId="pv-contact-after-steps" />
      <ContactForm compact />
    </PageShell>
  );
};

export default ContactPage;
